/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Table_UnitsInputs */

const es_billing_events_table_units = /** @type {(inputs: Billing_Events_Table_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unidades`)
};

const en_billing_events_table_units = /** @type {(inputs: Billing_Events_Table_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Units`)
};

/**
* | output |
* | --- |
* | "Units" |
*
* @param {Billing_Events_Table_UnitsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_table_units = /** @type {((inputs?: Billing_Events_Table_UnitsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Table_UnitsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_table_units(inputs)
	return en_billing_events_table_units(inputs)
});
export { billing_events_table_units as "billing.events.table.units" }